// pages/Dashboard.jsx
import DashboardLayout from "../../components/dashboard/DashboardLayout";
import AdminOrderRequests from "../../components/dashboard/AdminOrderRequests";

export default function Dashboard() {
  return (
    <DashboardLayout>
      <AdminOrderRequests />
    </DashboardLayout>
  );
}
